import * as listWarrantiesReducer from './list';
import * as addWarrantiesReducer from './add';
import * as vehicleReducer from './vehicle';
import * as listCategoryReducer from './listCategories';
import * as listImageReducer from './images';
import * as updateReducer from './update';

const Reducers = {
  ...listWarrantiesReducer,
  ...addWarrantiesReducer,
  ...vehicleReducer,
  ...listCategoryReducer,
  ...listImageReducer,
  ...updateReducer,
};

export default Reducers;
